import React, { Component } from "react";
// import "../styleCss/error404.css";
// import NavBar from "./navBar";
// import Footer from "./footer";
import { Link } from "react-router-dom";

class Error404 extends Component {
  state = {};
  render() {
    return (
      <div>
        <section id='change-background'>
          <div className='wrapper'>
            <div className='row my-5 mx-auto'>
              <div className='error '>
                <h1>
                  متاسفانه <br />
                  صفحه مورد نظر شما پیدا نشد
                </h1>
                <div className='error-img'></div>
                <Link tag={Link} to='/' className='back-home text-xs text-red-500'>
                  بازگشت به صفحه اصلی
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Error404;
